var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfollowPopUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C9.71527 19 9.44077 18.8957 9.22684 18.7061C8.41888 17.9914 7.63992 17.3198 6.95267 16.7274L6.94916 16.7243C4.93423 14.9873 3.19427 13.4873 1.98364 12.0096C0.630341 10.3576 0 8.79138 0 7.08032C0 5.41788 0.563507 3.88418 1.58661 2.76153C2.62192 1.62561 4.04251 1 5.58716 1C6.74164 1 7.79892 1.36922 8.72955 2.09733C9.19922 2.46486 9.62494 2.91466 10 3.43932C10.3752 2.91466 10.8008 2.46486 11.2706 2.09733C12.2012 1.36922 13.2585 1 14.413 1C15.9575 1 17.3782 1.62561 18.4135 2.76153C19.4366 3.88418 20 5.41788 20 7.08032C20 8.79138 19.3698 10.3576 18.0165 12.0094C16.8059 13.4873 15.0661 14.9872 13.0515 16.724C12.363 17.3173 11.5828 17.99 10.773 18.7064C10.5592 18.8957 10.2846 19 10 19Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowPopUp);
export default __webpack_public_path__ + "static/media/unfollowPopUp.0e792b9de7f61cbab3c6b0ab6c1a8f40.svg";
export { ForwardRef as ReactComponent };